import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { CreatePlanRequestDTO, UpdatePlanRequestDTO } from "../models/plan/plan.request";
import { PlanListItemDTO, PlanDetailsDTO, PlanBasicInfoDTO, PlanInputSelectDTO } from "../models/plan/plan.response";


export const planService = {

    async create(dto: CreatePlanRequestDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>('/plans', dto);
        return data;
    },

    async getPlans(): Promise<ApiResponse<PlanListItemDTO[]>> {
        const { data } = await api.get<ApiResponse<PlanListItemDTO[]>>('/plans');
        return data;
    },

    async hardDelete(planId: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/plans/${planId}`);
        return data;
    },

    async softDelete(planId: string): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/plans/${planId}/delete`);
        return data;
    },

    async restore(planId: string): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/plans/${planId}/restore`);
        return data;
    },

    async getPlan(planId: string): Promise<ApiResponse<PlanDetailsDTO>> {
        const { data } = await api.get<ApiResponse<PlanDetailsDTO>>(`/plans/${planId}`);
        return data;
    },

    async update(dto: UpdatePlanRequestDTO): Promise<ApiResponse<string>> {
        const { data } = await api.put<ApiResponse<string>>(`/plans/${dto.id}`, dto);
        return data;
    },

    async getBasicInfo(): Promise<ApiResponse<PlanBasicInfoDTO[]>> {
        const { data } = await api.get<ApiResponse<PlanBasicInfoDTO[]>>('/plans/basic-info');
        return data;
    },

    async getInputSelect(): Promise<ApiResponse<PlanInputSelectDTO[]>> {
        const { data } = await api.get<ApiResponse<PlanInputSelectDTO[]>>('/plans/input-select');
        return data;
    }

};